import { all } from "redux-saga/effects";

import { watchIntegrationsWebhook } from "./webhook/webhook.sagas";

export function *watchAdditionalResources () {
    yield all([
        watchIntegrationsWebhook()
    ]);
}